import { render, staticRenderFns } from "./LocationPerformanceChart.vue?vue&type=template&id=1bf077b0&scoped=true"
import script from "./LocationPerformanceChart.vue?vue&type=script&lang=js"
export * from "./LocationPerformanceChart.vue?vue&type=script&lang=js"
import style0 from "./LocationPerformanceChart.vue?vue&type=style&index=0&id=1bf077b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf077b0",
  null
  
)

export default component.exports